import { useState } from 'react'
import { useNavigate, useSearch } from '@tanstack/react-router'
import { SaleDetailDrawer } from '@features/sales'
import { WalletScreen } from '@features/wallet'
import { ReceiptsAccountNotice } from '@features/onboarding-kyc/ui/ReceiptsAccountNotice'
import type { StatementSearch } from '@features/wallet'

export function FinancasPage() {
  const search = useSearch({ from: '/protected/financas' })
  const navigate = useNavigate()
  const [saleId, setSaleId] = useState<string | null>(null)

  function updateSearch(next: StatementSearch) {
    void navigate({ to: '/financas', search: { ...next, currency: search.currency } })
  }

  return (
    <>
      <WalletScreen
        accountNotice={<ReceiptsAccountNotice />}
        search={search}
        currency={search.currency}
        onCurrencyChange={(currency) => {
          void navigate({ to: '/financas', search: { ...search, currency } })
        }}
        onSearchChange={updateSearch}
        onViewSale={setSaleId}
      />
      <SaleDetailDrawer scope="charge" saleId={saleId} onClose={() => setSaleId(null)} />
    </>
  )
}
